// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-26c5d13b] .tab-content .el-tabs__header {\n  margin-bottom: 20px !important;\n}\n[data-v-26c5d13b] .dialog-footer-inner {\n  float: left !important;\n}\n[data-v-26c5d13b] .closeBtn {\n  display: none;\n}\n[data-v-26c5d13b] .el-tabs__nav .el-tabs__item:nth-of-type(1) {\n  padding-left: 20px !important;\n}", ""]);
// Exports
module.exports = exports;
